import { titleCase } from 'title-case';

/**
 * Title Case Converter - Client-side solution using title-case npm package
 * Processes all headings (h1-h6) in post/page content and converts them to Title Case.
 *
 * Operates on text nodes only so it never destroys child elements such as
 * <strong>, <em>, or <span> created by the color/size/center snippet processors.
 */
export class TitleCaseProcessor {
  processHeadings(contentContainer) {
    if (!contentContainer) return;

    const headings = contentContainer.querySelectorAll('h1, h2, h3, h4, h5, h6');

    for (const heading of headings) {
      // Collect leaf text nodes, preserving DOM structure
      const textNodes = [];
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while ((node = walker.nextNode())) textNodes.push(node);

      if (textNodes.length === 0) continue;

      // Build full text and remember each node's character length
      const lengths = textNodes.map(tn => tn.textContent.length);
      const fullText = textNodes.map(tn => tn.textContent).join('');
      const trimmed  = fullText.trim();

      if (!trimmed) continue;

      try {
        const converted = titleCase(trimmed);
        if (converted === trimmed) continue;

        // Reconstruct full string, preserving any leading/trailing whitespace
        const leadingSpaces  = fullText.length - fullText.trimStart().length;
        const trailingSpaces = fullText.length - fullText.trimEnd().length;
        const convertedFull  =
          fullText.slice(0, leadingSpaces) +
          converted +
          (trailingSpaces > 0 ? fullText.slice(-trailingSpaces) : '');

        // Distribute characters back into the original text nodes
        let pos = 0;
        for (let i = 0; i < textNodes.length; i++) {
          textNodes[i].textContent = convertedFull.slice(pos, pos + lengths[i]);
          pos += lengths[i];
        }
      } catch (error) {
        console.error('[TitleCase] Error processing heading:', error);
      }
    }
  }

  init() {
    const contentContainer = document.querySelector('.gh-content, .js-toc-content');
    if (!contentContainer) return;

    // Run after snippet processors have built their DOM structure
    setTimeout(() => {
      this.processHeadings(contentContainer);
    }, 500);
  }
}

export function initTitleCaseProcessor() {
  new TitleCaseProcessor().init();
}
